{
  "City of Cape Town": "City of Cape Town",
  "Western Cape Provincial Government": "Western Cape Government",
  "National Government": "National Government",
  "State Owned Enterprise (SOE)": "SOEs",
  "Multi-Goverment": "Multi-Goverment"
}
